import React from 'react';
import { Link } from 'react-router-dom';

function normalizePath(path) {
  if (!path) return '/';
  return path.startsWith('/') ? path : `/${path}`;
}

export default props => (
  <li>
    <Link to={normalizePath(props.path)}>
      <i className={`fa fa-${props.icon}`} /> <span>{props.label}</span>
    </Link>
  </li>
);
